// GroupCardButton.tsx
import React from "react";
import { MdTune } from "react-icons/md";
import styles from "./GroupCardButton.module.scss";
import { useTheme } from "../../hooks/useTheme";

interface GroupCardButtonProps {
  appearance?: "default" | "compact";
  onPress: (e: React.MouseEvent) => void;
}

export const GroupCardButton: React.FC<GroupCardButtonProps> = ({
  appearance,
  onPress,
}) => {
  const { theme } = useTheme();
  const isCompact = appearance ? appearance === "compact" : true;

  return (
    <button
      className={`${styles.selectButton} ${isCompact ? styles.compact : ""}`}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onPress(e);
      }}
    >
      <MdTune size={16} color={theme.primary} />
      <span
        className={`${styles.selectButtonText} ${isCompact ? styles.compact : ""}`}
      >
        Выбрать
      </span>
    </button>
  );
};
